import React, { forwardRef, useState } from 'react';
import { useAvailability } from '../../contexts/AvailabilityContext';
import AvailabilityScheduler from '../schedule/AvailabilityScheduler';
import FormHeader from '../personal-info/FormHeader';
import SpinnerOverlay from '../ui/SpinnerOverlay';
import { useUser } from '../../contexts/UserContext';

const AvailabilitySection = forwardRef(({ active }, ref) => {
  const {
    daysOfWeek,
    timeSlots,
    availability,
    toggleCell,
    toggleDay,
    toggleTime,
    toggleAll,
    saveAvailability,
  } = useAvailability();

  const { showAlert } = useUser();
  const [isSaving, setIsSaving] = useState(false);

  const handleSaveAvailability = async () => {
    setIsSaving(true);
    try {
      await saveAvailability();
      showAlert('שעות הזמינות נשמרו בהצלחה', 'success');
    } catch (err) {
      showAlert(err?.message || 'אירעה שגיאה בשמירת שעות הזמינות', 'error');
    } finally {
      setIsSaving(false);
    }
  };

  if (!active) return null;

  return (
    <div
      dir="rtl"
      ref={ref}
      id="availability-section"
      className="scroll-mt-24"
    >
      <div className="relative bg-white rounded-2xl shadow-md border border-gray-100 p-4 sm:p-6 mb-4 sm:mb-6">
        {isSaving && (
          <SpinnerOverlay
            variant="glow"
            text="נא להמתין"
            dark={false}
            blur={false}
          />
        )}

        <FormHeader
          title="הגדרת שעות עבודה"
          buttonText="שמירת שינויים"
          onClick={handleSaveAvailability}
          type="button"
          disabled={isSaving}
        />

        <div className="overflow-x-auto -mx-4 sm:mx-0 px-4 sm:px-0">
          <AvailabilityScheduler
            daysOfWeek={daysOfWeek}
            timeSlots={timeSlots}
            availability={availability}
            toggleCell={toggleCell}
            toggleDay={toggleDay}
            toggleTime={toggleTime}
            toggleAll={toggleAll}
          />
        </div>

        <p className="mt-3 sm:mt-4 text-xs sm:text-sm text-gray-400 text-right">
          לחץ על תא כדי לסמן/לבטל זמינות, או לחץ על יום/שעה לסימון שורה/עמודה שלמה
        </p>
      </div>
    </div>
  );
});

export default AvailabilitySection;